import { Suspense } from "react";
import { ComponentsE } from "App";
import * as components from "@components/Pages";
import Loader from "@components/global/Loader/Loader";
import ChunkErrorBoundary from "@components/ErrorBoundary/ChunkErrorBoundary";

export const SuspendComponent = (
  Component: ComponentsE,
  params?: { [key: string]: boolean }
): JSX.Element => {
  const useComponent = (c: ComponentsE): JSX.Element => {
    const Component = components.default[c];
    return <Component />;
  };
  return (
    <ChunkErrorBoundary>
      <Suspense fallback={<Loader fill />}>{useComponent(Component)}</Suspense>
    </ChunkErrorBoundary>
  );
};
